//imports
import { all } from 'redux-saga/effects';

//Views
import createEditSimProviderAccountSagas from 'Modules/simProviderAccounts/views/.components/createEditSimProviderAccount/redux/saga';
import deleteSimProviderAccountSagas from 'Modules/simProviderAccounts/views/.components/deleteSimProviderAccount/redux/saga';
//merge sagas
export default function* rootSaga() {
    yield all([
        createEditSimProviderAccountSagas(),
        deleteSimProviderAccountSagas(),
    ]);
}